import { render, staticRenderFns } from "./PrivateOutlineItemPage.vue?vue&type=template&id=6d5fd54a&"
import script from "./PrivateOutlineItemPage.vue?vue&type=script&lang=js&"
export * from "./PrivateOutlineItemPage.vue?vue&type=script&lang=js&"
import style0 from "./PrivateOutlineItemPage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports